import { useEffect, useState } from "react";
import { presenceService } from "../../api/presenceService";

/** Is the signed-in employee a squad lead (may open Team Presence for their squads)? */
const usePresenceAccess = (enabled = true) => {
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(enabled);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    presenceService
      .getAccess()
      .then((a) => !cancelled && setAccess(a))
      .catch(() => !cancelled && setAccess(null))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return { access, loading };
};

export default usePresenceAccess;
